import ReactPixel from "@bettercart/react-facebook-pixel";
import ReactGA from "react-ga4";
import SnapchatPixel from "react-snapchat-pixel";
import TiktokPixel from "../tiktok-pixel";
import TwitterPixel from "../TwitterPixel";
import PinterestPixel from "../PinterestPixel";
import { GTM } from "./tagManager";
import { marketingUnitPrice } from "./purchaseTracking";
import { FacebookInitiateCheckout, SnapchatCheckout, TikTokInitiateCheckout, generateUniqueID } from "./analytics";

// Preserve the existing v1 event contracts when replacement UI handles an action.
// A tracker failure must never prevent navigation or a successful cart mutation.
const safely = callback => { try { callback(); } catch (_) {} };

export const trackCheckoutStarted = props => safely(() => {
    if (props.settings.enable_fb_pixel && props.settings.fb_pixel) {
      const eventId = generateUniqueID(10);
      ReactPixel.track(
        "InitiateCheckout",
        {
          event_id: eventId,
          currency: props.settings.currency_iso,
          value: props.cart.price,
        },
        { eventID: eventId },
      );
      if (props.settings.enable_conversion_api) {
        FacebookInitiateCheckout(eventId);
      }
    }
    if (
      props.settings.enable_snap_pixel &&
      props.settings.snap_pixel
    ) {
      SnapchatCheckout(props);
    }
    if (
      props.settings.enable_google_analytics &&
      props.settings.google_analytics
    ) {
      ReactGA.event({
        category: "orders",
        action: "customer reviews purchase",
        label: "begin_checkout",
      });
      ReactGA.gtag("event", "begin_checkout", {
        currency: props.settings.currency_iso,
        value: props.cart.price,
        items: props.cart.cart.map((item) => ({
          item_id: item.id,
          item_name: item.name,
          currency: props.settings.currency_iso,
          price: marketingUnitPrice(item),
          quantity: item.quantity,
        })),
      });
    }
    if (GTM) {
      GTM.track("begin_checkout", {
        ecommerce: {
          currency: props.settings.currency_iso,
          value: props.cart.price,
          items: props.cart.cart.map((item) => {
            return {
              item_id: item.id,
              item_name: item.name,
              currency: props.settings.currency_iso,
              price: marketingUnitPrice(item),
              quantity: item.quantity,
            };
          }),
        },
      });
    }

    if (
      props.settings.enable_tiktok_pixel &&
      props.settings.tiktok_pixel
    ) {
      TikTokInitiateCheckout(props);
    }
    if (TwitterPixel.isInitialized()) {
      if (props.settings.twitter_events["Checkout Initiated"]) {
        TwitterPixel.track(
          props.settings.twitter_events["Checkout Initiated"],
        );
      }
    }
});

export const trackSearchResult = props => safely(() => {
    const { settings } = props;

    if (props.settings.enable_fb_pixel && props.settings.fb_pixel) {
      ReactPixel.track("Search", {
        content_category: props.product.category,
        content_ids: [props.product.id.toString()],
        currency: settings.currency_iso,
        search_string: props.filter_value,
        value: props.product.price,
      });
    }
    if (
      props.settings.enable_google_analytics &&
      props.settings.google_analytics
    ) {
      ReactGA.event({
        category: "Search",
        action: `User Searched for ${props.product.name} Using the String ${props.filter_value}`,
        label: "Search",
      });
    }

    if (
      props.settings.enable_snap_pixel &&
      props.settings.snap_pixel
    ) {
      SnapchatPixel.track("SEARCH", {
        currency: settings.currency_iso,
        price: props.product.price,
        item_category: props.product.category,
        item_ids: [props.product.id],
        search_string: props.filter_value,
        integration: "ordable",
      });
    }
    if (GTM) {
      GTM.track("search", {
        content_category: props.product.category,
        content_ids: props.product.id,
        currency: settings.currency_iso,
        search_string: props.filter_value,
        value: props.product.price,
      });
    }
    if (
      props.settings.enable_tiktok_pixel &&
      props.settings.tiktok_pixel
    ) {
      TiktokPixel.track("Search", {
        content_id: props.product.id.toString(),
        content_type: "product",
        query: props.filter_value,
      });
    }
    if (TwitterPixel.isInitialized()) {
      if (props.settings.twitter_events["Search"]) {
        TwitterPixel.track(props.settings.twitter_events["Search"], {
          search_string: props.filter_value,
          contents: [
            {
              content_type: "product",
              content_id: props.product.id,
              content_name: props.product.name,
              content_price: props.product.price,
              num_items: 1,
            },
          ],
        });
      }
    }
    if (PinterestPixel.isInitialized()) {
      PinterestPixel.track("search", {
        event_id: `search-${generateUniqueID(10)}`,
        property: props.filter_value,
      });
    }
});

export const trackCartRemoval = (settings, product) => safely(() => {


    if (settings.enable_google_analytics && settings.google_analytics) {
      ReactGA.event({
        category: "Removed From Cart",
        action: `User Removed ${product.name} From Cart`,
        label: "Removed From Cart",
      });

      ReactGA.gtag("event", "remove_from_cart", {
        value: product.price * product.quantity,
        currency: settings.currency_iso,
        items: [
          {
            item_id: product.id,
            item_name: product.name || "",
            price: product.price,
            quantity: product.quantity,
          },
        ],
      });
    }
    if (GTM) {
      GTM.track("remove_from_cart", {
        ecommerce: {
          items: [
            {
              item_id: product.id,
              item_name: product.name,
              currency: settings.currency_iso,
              price: product.price,
              quantity: product.quantity,
            },
          ],
        },
      });
    }
});
